import { FC, ReactElement } from 'react';

import {
	AzureDevopsTicketCreator,
	BUTTON_TYPES,
	EvButton,
	EvLink
} from '@evinced-private/ui-common';

import { JiraApi } from 'src/common/services/api/JiraApi';

import { ITicketsSystems } from './TicketsSystems.types';
import { ADD_TO_TICKET_SYSTEM_BTN_ID } from './TicketSystems.constants';
import { useTicketsSystems } from './useTicketsSystems';

export const TicketsSystems: FC<ITicketsSystems> = (props) => {
	const {
		enableAzureIntegration,
		enableAzureBypassRule,
		azureConfig,
		azureTicket,
		isJiraConnected,
		exportToJira,
		renderJiraModal
	} = useTicketsSystems(props);

	const renderAddToJiraButton = (): ReactElement =>
		isJiraConnected ? (
			<EvButton type={BUTTON_TYPES.PRIMARY} onClick={exportToJira}>
				Add to Jira
			</EvButton>
		) : (
			<EvLink url={JiraApi.getJiraAuthURL()} linkText="Connect to Jira" openInNewTab={true} />
		);

	return (
		<>
			{enableAzureIntegration ? (
				<AzureDevopsTicketCreator
					config={azureConfig}
					ticket={azureTicket}
					bypassRules={enableAzureBypassRule}
					dataAutomationId={ADD_TO_TICKET_SYSTEM_BTN_ID}
				/>
			) : (
				renderAddToJiraButton()
			)}
			{renderJiraModal()}
		</>
	);
};
